module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar'), _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-offset-3 col-md-6 text-center"
  }, [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": _vm.handleSubmit
    }
  }, [_c('select', {
    staticClass: "form-control input-lg"
  }, _vm._l((_vm.app.routes), function(route) {
    return _c('option', {
      domProps: {
        "value": route.path
      }
    }, [_vm._v(_vm._s(route.name))])
  }), 0), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "padding-left": "3rem",
      "padding-right": "3rem",
      "margin-left": "1rem"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Go")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-offset-3 col-md-6 text-center",
    staticStyle: {
      "margin-top": "5rem"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-bottom": "2rem",
      "color": "#888"
    }
  }, [_vm._v("Make email for")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd6b0624"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Home.vue
// module id = 231
// module chunks = 0